import { CreateTemplateCategory, CreateTemplateCategoryVariables } from './__generated__/CreateTemplateCategory'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation CreateTemplateCategory($input: CreateTemplateCategoryInputV2!) {
    createTemplateCategory: createTemplateCategoryV2(input: $input) {
      ... on TemplateCategoryV2 {
        id
        title
      }
      ... on TemplateCategoryErrorV2 {
        type
        error
      }
    }
  }
`

export const useCreateTemplateCategory = () =>
  useMutation<CreateTemplateCategory, CreateTemplateCategoryVariables>(MUTATION)
